import { cn } from "@/lib/utils";
import Image from "next/image";

const Learners = ({
  metadata,
  description,
  descriptionColor = "#000000",
  learners_description_section_color,
}: {
  metadata: any;
  description: any;
  descriptionColor?: string;
  learners_description_section_color?: string;
}) => {
  return (
    <div
      className={cn(
        "flex items-center border border-primary-3 bg-white",
        "xs:px-[18px] xs:py-[14px] xs:gap-4 xs:rounded-xl",
        "sm:p-2 sm:gap-4 sm:rounded-br-lg sm:rounded-tl-lg",
        "md:gap-5",
        "lg:p-[10px] lg:gap-6",
        "xl:p-3 xl:gap-7"
      )}
      style={{
        backgroundColor: learners_description_section_color || "#ffffff",
      }}
    >
      <div className="flex shrink-0">
        {metadata &&
          metadata.length > 0 &&
          metadata?.map?.(
            (item: any, index: number) =>
              item?.image && (
                <div
                  key={item.id || index}
                  className={cn(
                    "sm:border-[1.6px]",
                    "md:border-[1.8px]",
                    "lg:border-[2px]",
                    "xl:border-[2.6px]",
                    "bg-white border-secondary-main rounded-full overflow-hidden",
                    index !== 0 && "-ml-3"
                  )}
                >
                  <Image
                    src={item?.image || ""}
                    alt={item?.alt_image || ""}
                    width={100}
                    height={100}
                    className={cn(
                      "rounded-full object-cover",
                      "xs:w-9 xs:h-9",
                      "sm:size-9",
                      "md:size-[42px]",
                      "lg:size-12",
                      "xl:size-15"
                    )}
                  />
                </div>
              )
          )}
      </div>
      <div
        dangerouslySetInnerHTML={{ __html: description || "" }}
        className={cn("line-clamp-2 flex-1 min-w-0")}
        style={{ color: descriptionColor }}
      />
    </div>
  );
};

export default Learners;
